var _defs, _g, _g2, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs3069"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3135",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3136",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3137",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3139",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3140",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3141",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3224",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3225",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3226",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3228",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3229",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3230",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3234",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3235",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3236",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3238",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3239",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3240",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3242",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3243",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3244",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3247",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3248",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3249",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3251",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3252",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3253",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3257",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3258",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3259",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3261",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3262",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3263",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3265",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3266",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3267",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3472",
    x1: 100,
    y1: 144,
    x2: 100,
    y2: 141,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3473",
    stopOpacity: 1,
    stopColor: "#e8b9a0",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3474",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3528",
    x1: 100,
    y1: 171,
    x2: 100,
    y2: 130,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3529",
    stopOpacity: 0.8,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3530",
    stopOpacity: 1,
    stopColor: "#c27b55",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4647",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4648",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4649",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.315
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4650",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.504
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4651",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4652",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4654",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4655",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4656",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4657",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4658",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4659",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4661",
    cx: 129.041,
    cy: 83.945,
    r: 15.117,
    gradientTransform: "matrix(-0.9945 0.1042 0.1042 0.9945 192.8281 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4662",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4663",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4664",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4665",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4666",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4670",
    cx: 121.986,
    cy: 82.496,
    fx: 133.239,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(0.9998 0.0208 0.0166 -0.7998 -45.3195 145.9395)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4671",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4672",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4673",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4675",
    cx: 68.931,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4676",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4677",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4681",
    cx: 128.643,
    cy: 83.986,
    r: 15.116,
    gradientTransform: "matrix(0.9945 0.1042 -0.1042 0.9945 7.1738 -12.4633)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4682",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4683",
    stopOpacity: 1,
    stopColor: "#fcfdfd",
    offset: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4684",
    stopOpacity: 1,
    stopColor: "#f4f7f8",
    offset: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4685",
    stopOpacity: 1,
    stopColor: "#e5ecef",
    offset: 0.661
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4686",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4690",
    cx: 121.587,
    cy: 82.496,
    fx: 132.839,
    fy: 82.527,
    r: 16.003,
    gradientTransform: "matrix(-0.9998 0.0208 -0.0166 -0.7998 244.5208 145.9478)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4691",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4692",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4693",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4695",
    cx: 69.316,
    cy: 105.995,
    r: 29.524,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.6796 1.3127)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4696",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4697",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4743",
    x1: 100,
    y1: 110,
    x2: 100,
    y2: 73,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4744",
    stopOpacity: 0.6,
    stopColor: "#151124",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4745",
    stopOpacity: 1,
    stopColor: "#151124",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4777",
    x1: 128,
    y1: 106,
    x2: 128,
    y2: 69,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4778",
    stopOpacity: 0.95,
    stopColor: "#edd218",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4779",
    stopOpacity: 1,
    stopColor: "#edd218",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4781",
    x1: 72,
    y1: 106,
    x2: 72,
    y2: 69,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4782",
    stopOpacity: 0.95,
    stopColor: "#edd218",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4783",
    stopOpacity: 1,
    stopColor: "#edd218",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5087",
    cx: 100,
    cy: 225,
    r: 250,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-backs-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5088",
    stopOpacity: 0,
    stopColor: "#e5fcc2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5089",
    stopOpacity: 1,
    stopColor: "#ceed9f",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5101",
    d: "M225 225H-25V-25h250V225z",
    fill: "#c6c6c6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(0.9799999,0,0,0.9998999000000001,1.9592698976188672,0.009049841276549841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4898",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#543c32",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3142",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3143",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffe4d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3144",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3145",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3527",
    d: "M75.602 162.779c7.126 5.302 15.497 9.087 24.401 9.087 8.902 0 17.269-3.781 24.394-9.08 -0.104-0.358-0.17-0.718-0.175-1.053 -0.088-6.862 1.561-20.607 2.82-30.025 -15.654-1.97-38.431-1.97-54.084 0 1.26 9.419 2.908 23.163 2.819 30.024C75.773 162.063 75.707 162.42 75.602 162.779z",
    fill: "url(#SvgjsLinearGradient3528)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5092",
    d: "M42.77 235.757l1.323-60.852c0 0 10.194-2.487 16.635-6.313 17.496 21.953 69.451 17.333 78.336-0.62 1.489 0.525 2.721 1.197 4.262 1.713 5 3.386 9.213 4.494 9.213 4.494l0.935 61.685C139.188 236.052 42.77 235.757 42.77 235.757z",
    fill: "#f5f4f5",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5093",
    d: "M154.014 177.705c-4.236-0.719-7.611-1.697-9.452-3.544 -5.343 10.025-26.763 16.378-33.855 17.309 20.554-6.276 29.188-10.813 32.598-21.583 1.99 2.383 6.522 3.549 12.313 4.538L154.014 177.705zM52.67 174.381c1.454-0.312 2.18-1.234 3.623-1.593l-1.528-1.867c-3.114 2.234-8.971 3.305-15.9 4.424l0.188 3.738c3.956-0.79 7.817-1.788 11.429-3.323 7.483 8.485 19.168 12.659 31.06 14.387C66.624 186.562 58.07 180.511 52.67 174.381z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5094",
    d: "M137.861 170.055c-5.929 11.361-50.74 24.595-76.009 0.866 -1.571 0.615-6.271 2.085-6.271 2.085 18.406 23.08 72.345 23.227 86.702-0.112C142.221 172.87 139.321 170.737 137.861 170.055z",
    fill: "#dfdde2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5095",
    d: "M139.008 167.841c-10.087 18.575-62.578 21.204-78.239 0.625 -5.72 1.556-11.219 4.876-16.756 5.707l-1.243 61.584 110.703 0.107 -0.855-62.386c-3.369-0.707-6.501-2.737-9.254-3.894C141.842 168.945 140.55 168.37 139.008 167.841zM60.39 169.087c13.903 23.086 68.817 18.455 79.419 0.099 1.286 0.499 1.615 0.696 3.106 1.183 -10.982 21.208-65.306 27.967-87.525 1.147C55.546 171.476 58.823 169.629 60.39 169.087zM54.287 172.418c17.963 27.046 77.26 22.856 89.583-1.287 1.771 1.391 4.53 2.989 7.936 3.735l1.66 59.08 -110.377 0.016 1.904-58.299C47.777 174.264 52.247 173.232 54.287 172.418z",
    fill: "#b8b6c9",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5096",
    d: "M-4.529 235.566c-2.574-13.852-2.292-47.592 9.013-47.521 13.136-5.311 29.269-11.404 42.802-15.311 6.908-7.246 13.436-14.137 26.188-21.314 0.389 2.599 1.874 8.541 0.011 11.773 -1.355 2.352-5.783 5.576-9.554 8.368 -2.029 2.72-3.927 5.374-6.599 9.089 5.168 22.301 9.601 33.78 10.097 53.123 0 0-1.452 0.689 64.471 0.397 2.215-22.339 4.993-33.561 10.379-54.098 0 0-4.308-5.014-7.207-8.87 -2.054-1.997-8.36-7.532-8.84-8.651 -1.175-2.741-0.548-6.188 0.11-11.367 10.793 4.873 17 12.021 26.082 21.303 7.729 2.119 30.86 9.967 42.445 15.216 3.965-0.11 6.203 1.999 7.872 5.466 5.405 11.195 4.126 27.297 2.18 42.789C185.83 235.989 49.887 238.17-4.529 235.566z",
    fill: "#1d282e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5097",
    d: "M73.875 154.081c0.16 1.07 0.304 2.085 0.411 3.041 -0.218 0.266-17.212 23.353-17.336 23.525C61.126 171.148 67.1 161.305 73.875 154.081zM126.053 154.081c-0.159 1.07-0.184 2.085-0.291 3.041 0.218 0.266 16.931 22.469 17.054 22.642C138.391 170.914 132.828 161.305 126.053 154.081zM165.008 185.154c-4.28 6.231-5.194 8.382-9.879 14.557 1.071 0 2.799 0.166 3.87 0.166C162.663 193.592 162.67 190.393 165.008 185.154zM169.394 230.379c3.793-8.9 6.934-16.711 10.739-25.624l-1.247-2.014C175.717 211.896 172.354 221.199 169.394 230.379zM41.048 199.877c1.071 0 2.799-0.166 3.871-0.166 -4.685-6.175-5.599-6.561-9.878-12.792C37.377 192.158 37.384 193.592 41.048 199.877zM21.161 202.741l-1.247 2.014c3.806 8.913 4.765 16.724 8.559 25.624C25.512 221.199 24.33 211.896 21.161 202.741z",
    fill: "#101a1f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5098",
    d: "M65.638 169.283c1.181-1.646 5.237-7.272 8.601-12.561C75.227 162.179 73.413 165.416 65.638 169.283zM125.74 156.36c2.553 4.396 5.562 8.772 8.664 12.803C126 165.336 125.435 161.423 125.74 156.36z",
    fill: "#070c0f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5099",
    d: "M126.318 151.359c0.008-0.061 0.017-0.118 0.023-0.174 18.093 9.999 28.576 25.02 40.747 36.217 -0.448 0.721-1.228 1.193-1.687 1.905C152.656 179.609 146.599 164.946 126.318 151.359zM71.736 152.022c-15.034 8.213-36.242 33.357-38.318 35.269 0.448 0.724 0.691 0.577 1.15 1.288C47.314 178.882 50.793 169.283 71.736 152.022zM194.869 187.704c-1-0.799-24.646-10.039-42.59-14.969 33.698 16.299 45.587 18.545 51.471 24.321C203.367 196.057 202.586 187.489 194.869 187.704zM47.458 172.555c-13.524 3.914-30.839 10.098-42.975 15.491 -5.364 0.106-9.208 7.93-10.031 16.084C1.914 187.317-1.773 198.62 47.458 172.555z",
    fill: "#2d373d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5100",
    d: "M206.6 210.062c-0.34-8.635-3.055-23.103-11.691-22.46 -0.714-0.61-20.822-9.767-42.285-15.611 -7.353-7.455-16.515-17.598-26.371-20.957 -0.711 6.428-1.477 10.622 0.216 12.714 2.241 2.439 4.93 4.879 7.568 6.522 4.616 6.136 8.139 9.778 8.139 9.778 -5.43 20.703-8.815 31.314-10.973 53.688H68.798c-2.157-22.373-5.543-32.984-10.973-53.688 0 0 3.522-3.643 8.139-9.778 2.639-1.644 5.327-4.083 7.568-6.522 1.692-2.092 0.927-6.286 0.216-12.714 -9.856 3.359-19.019 13.502-26.371 20.957 -21.463 5.845-41.571 15.001-42.285 15.611 -8.637-0.643-11.352 13.825-11.691 22.46 -0.411 10.487 1.435 24.938 1.585 25.938h210.029C205.165 234.999 207.011 220.549 206.6 210.062zM72.984 163.194c-2.258 2.233-3.658 3.181-6.473 5.282 4.829-6.271 4.341-5.433 7.708-11.229C74.37 159.739 73.433 162.751 72.984 163.194zM-3.172 234.028c-1.082-12.844-2.916-24.41 0.43-36.992 1.281-4.827 2.484-8.095 7.455-8.509 1.067 5.538 8.132 28.724 14.298 44.533 -6.226-24.192-5.311-18.81-8.219-28.452 -0.964-3.235-1.854-6.486-2.979-9.672 -0.783-2.214-1.65-4.387-2.262-6.653l40.433-14.865c-0.279 0.283-12.895 13.434-13.199 13.804 1.847 3.021 7.816 7.222 10.845 11.758 -12.436 1.174-18.508 3.173-23 3.84 0.331 0.919 9.061 25.353 9.976 27.656 -1.479-7.917-4.816-20.297-8.637-27.211 1.41-0.179 18.077-2.492 23.393-3.477 -1.476-2.854-8.043-8.437-11.559-12.619 20.646-18.162 25.422-27.402 39.593-35.454 0.15 1.509 0.443 3.011 0.55 4.519 -15.795 23.533-17.649 23.567-17.649 23.567 4.585 17.81 10.532 35.824 10.532 54.073L-3.172 234.028zM127.016 163.194c-0.448-0.443-1.386-3.455-1.235-5.947 3.367 5.797 2.879 4.958 7.708 11.229C130.674 166.375 129.273 165.428 127.016 163.194zM203.172 234.028l-70-0.154c0-18.249 5.947-36.264 10.532-54.073 0 0-1.854-0.034-17.649-23.567 0.106-1.508 0.399-3.01 0.55-4.519 14.171 8.052 18.946 17.292 39.593 35.454 -3.516 4.183-10.083 9.766-11.559 12.619 5.315 0.984 21.982 3.298 23.393 3.477 -3.82 6.914-7.157 19.294-8.637 27.211 0.915-2.304 9.645-26.737 9.976-27.656 -4.492-0.667-10.564-2.666-23-3.84 3.028-4.536 8.998-8.736 10.845-11.758 -0.305-0.37-12.92-13.521-13.199-13.804 0.001 0 40.433 14.865 40.433 14.865 -0.611 2.267-1.479 4.439-2.262 6.653 -1.125 3.186-2.015 6.437-2.979 9.672 -2.908 9.643-1.993 4.26-8.219 28.452 6.166-15.81 13.23-38.995 14.298-44.533 4.971 0.414 6.174 3.682 7.455 8.509C206.088 209.618 204.254 221.185 203.172 234.028z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,1.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(0.9499999,0,0,0.9499999,2.2241708416128176,4.849904795615387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3552",
    d: "M47.001 83.231c-1.376-2.453-5.638-8.48-9.98-7.003 -2.749 0.935-3.293 3.993-3.735 6.693 -0.588 3.591 0.471 10.694 1.389 13.26 0.881 2.467 3.533 7.23 5.264 9.045 2.13 2.225 4.775 9.324 5.194 10.061 0.66 1.162 1.536 2.911 4.122 2.692 2.853-0.244 4.584-1.85 5.856-2.121C58.253 115.192 50.582 89.616 47.001 83.231z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3553",
    d: "M44.197 98.104c-0.132-0.581 0.007-1.56 0.142-2.504 0.124-0.861 0.24-1.675 0.169-2.251 -0.267-2.154-1.773-6.249-2.757-8.467 -1.132-2.554-2.963-5.77-5.262-6.599 -0.95-0.343-1.575 0.067-1.938 0.484 -0.266 0.305-0.325 0.665-0.238 0.707 0.086 0.042 0.285-0.254 0.572-0.535 0.235-0.229 0.579-0.426 1.051-0.385 -0.19 1.073-1.167 6.883-0.744 10.845 0.333 3.115 1.593 5.442 1.79 5.791 0.029 0.367 0.077 0.726 0.148 1.075 0.929 4.547 4.971 9.717 6.378 11.409 0.259 0.313 0.531 0.497 0.598 0.423 0.066-0.076-0.094-0.387-0.353-0.7 -1.388-1.679-5.391-6.831-6.289-11.218 -0.952-4.656 2.318-11.556 3.048-13.017 0.371 0.685 0.687 1.344 0.93 1.893 0.19 0.431 0.402 0.936 0.619 1.479 -0.429 0.762-3.434 6.32-2.338 10.767 0.406 1.641 2.235 3.755 3.447 4.333 0.667 0.32 0.919 0.797 1.209 1.349 0.336 0.64 0.718 1.365 1.828 1.892 0.225 0.108 0.429 0.151 0.61 0.151 0.313 0 0.551-0.135 0.725-0.293 0.018 0.28 0.017 0.64 0.009 0.97 -0.012 0.431 0.042 0.783 0.137 0.791 0.094 0.008 0.196-0.332 0.207-0.76 0.016-0.526 0.013-1.177-0.072-1.488 -0.248-0.917-1.008-1.953-1.813-3.048C45.221 100.116 44.403 99.003 44.197 98.104zM36.95 94.073c-2.177-7.139 0.656-13.3 1.144-14.28 0.85 0.822 1.6 1.919 2.21 2.995C39.86 83.646 37.041 89.271 36.95 94.073zM46.341 104.515c-1.004-0.475-1.339-1.115-1.666-1.733 -0.293-0.559-0.598-1.136-1.369-1.505 -0.168-0.081-0.352-0.203-0.542-0.343 -2.486-6.263 0.272-9.001 0.963-9.562 0.211 0.766 0.369 1.468 0.439 2.031 0.063 0.517-0.052 1.339-0.167 2.134 -0.142 0.985-0.286 2.004-0.137 2.664 0.226 0.982 1.069 2.131 1.884 3.242 0.723 0.986 1.466 2.003 1.721 2.832C47.359 104.439 47.017 104.836 46.341 104.515z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,-1.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(0.9499999,0,0,0.9499999,7.762725333769225,4.849904795615387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3554",
    d: "M152.736 83.231c1.377-2.453 5.639-8.48 9.98-7.003 2.75 0.935 3.293 3.993 3.736 6.693 0.588 3.591-0.471 10.694-1.389 13.26 -0.881 2.467-3.533 7.23-5.266 9.045 -2.129 2.225-4.775 9.324-5.193 10.061 -0.658 1.162-1.535 2.911-4.121 2.692 -2.854-0.244-4.584-1.85-5.857-2.121C141.484 115.192 149.156 89.616 152.736 83.231z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3555",
    d: "M153.727 101.196c-0.805 1.096-1.564 2.131-1.813 3.048 -0.086 0.311-0.088 0.962-0.072 1.488 0.012 0.428 0.113 0.768 0.207 0.76s0.148-0.36 0.137-0.791c-0.008-0.331-0.008-0.69 0.01-0.97 0.174 0.158 0.412 0.293 0.725 0.293 0.182 0 0.385-0.043 0.609-0.151 1.109-0.526 1.492-1.252 1.828-1.892 0.289-0.552 0.543-1.028 1.209-1.349 1.213-0.578 3.041-2.692 3.447-4.333 1.096-4.447-1.908-10.005-2.338-10.767 0.217-0.544 0.43-1.049 0.619-1.479 0.244-0.549 0.559-1.208 0.93-1.893 0.73 1.46 4 8.361 3.049 13.017 -0.896 4.387-4.9 9.539-6.289 11.218 -0.258 0.313-0.418 0.624-0.352 0.7 0.066 0.074 0.338-0.109 0.598-0.423 1.406-1.692 5.449-6.862 6.379-11.409 0.07-0.35 0.117-0.708 0.146-1.075 0.197-0.349 1.459-2.676 1.791-5.791 0.422-3.961-0.555-9.772-0.744-10.845 0.473-0.042 0.814 0.156 1.051 0.385 0.287 0.281 0.486 0.577 0.572 0.535 0.086-0.042 0.027-0.402-0.238-0.707 -0.363-0.417-0.988-0.827-1.938-0.484 -2.299 0.83-4.131 4.045-5.262 6.599 -0.984 2.218-2.49 6.313-2.758 8.467 -0.072 0.576 0.045 1.39 0.17 2.251 0.135 0.945 0.273 1.924 0.141 2.504C155.336 99.003 154.518 100.116 153.727 101.196zM159.434 82.787c0.611-1.075 1.361-2.173 2.211-2.995 0.488 0.98 3.32 7.141 1.145 14.28C162.697 89.271 159.879 83.646 159.434 82.787zM152.27 104.275c0.254-0.829 0.998-1.846 1.721-2.832 0.816-1.111 1.658-2.26 1.885-3.242 0.148-0.66 0.004-1.679-0.137-2.664 -0.115-0.795-0.23-1.617-0.166-2.134 0.068-0.563 0.227-1.266 0.438-2.031 0.691 0.561 3.449 3.299 0.965 9.562 -0.191 0.14-0.375 0.263-0.543 0.343 -0.771 0.369-1.074 0.946-1.369 1.505 -0.326 0.618-0.662 1.258-1.666 1.733C152.721 104.836 152.379 104.439 152.27 104.275z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(0.9799999,0,0,0.9998999000000001,2.0000500545215516,0.008144832581535866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3524",
    d: "M100.002 0.867C66.381 0.813 39.186 28.343 39.134 62.366c-0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.582 0 38.32-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.819 28.343 133.623 0.813 100.002 0.867z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3525",
    d: "M120.754 4.512c21.441 9.489 36.411 31.135 36.45 56.363 0.008 5.403-0.669 10.645-1.953 15.641l-0.005 0c-0.011 0.054-8.713 39.24-14.519 51.177 -5.709 11.738-21.608 32.469-40.725 32.469s-35.016-20.73-40.725-32.469c-5.806-11.937-14.507-51.123-14.519-51.177l-0.004 0c-1.284-4.997-1.962-10.238-1.953-15.641 0.038-25.229 15.008-46.874 36.45-56.363 -23.386 8.55-40.076 31.208-40.117 57.854 -0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.579 0 38.319-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.83 35.72 144.14 13.062 120.754 4.512z",
    fill: "#e8b9a0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3526",
    d: "M100.002 0.867C66.381 0.813 39.186 28.343 39.134 62.366c-0.008 5.403 0.669 10.645 1.953 15.641l0.004 0c0.011 0.054 8.713 39.241 14.519 51.175 6.073 12.487 23.814 32.685 44.392 32.685 20.582 0 38.32-20.197 44.392-32.685 5.805-11.935 14.507-51.122 14.519-51.175l0.005 0c1.283-4.997 1.961-10.238 1.952-15.641C160.819 28.343 133.623 0.813 100.002 0.867z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1.0500001,0,0,1.0500001,-5.0000031335311945,-6.846556051483162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3531",
    d: "M100.34 141.925c-1.526 0-2.998-0.193-3.9-0.547 -0.257-0.102-0.384-0.392-0.283-0.648 0.101-0.257 0.39-0.383 0.648-0.283 1.664 0.653 5.855 0.676 7.704-0.193 0.251-0.117 0.548-0.01 0.665 0.239 0.118 0.25 0.011 0.548-0.239 0.665C103.815 141.684 102.044 141.925 100.34 141.925zM115.025 133.444c0.398-0.171 0.584-0.632 0.413-1.031s-0.635-0.583-1.031-0.413c-11.666 4.992-28.742 0.338-28.912 0.292 -0.417-0.116-0.852 0.127-0.968 0.546 -0.116 0.418 0.128 0.851 0.546 0.968 0.463 0.128 7.692 2.1 16.034 2.1C105.727 135.905 110.685 135.301 115.025 133.444z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1.0500001,0,0,1.0500001,-3.69895740247766,-4.043453292578903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4646",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient4647)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1.1000003000000003,0,0,1.1000003000000003,-7.400093916523758,-8.399954627888889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4761",
    d: "M79.788 85.588c-0.869 3.192-4.162 5.073-7.361 4.196 -3.197-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.168-5.076 7.365-4.198C78.772 79.09 80.659 82.392 79.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4762",
    d: "M78.855 85.662c-0.849 2.452-3.407 3.881-5.899 3.199 -2.3-0.631-3.752-2.838-3.563-5.171 0.853-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.592 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.039-0.147 0.06-0.294 0.065-0.439C77.29 84.782 78.088 85.165 78.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4763",
    d: "M74.813 82.21c-1.203-0.344-2.429 0.342-2.739 1.54 -0.311 1.191 0.412 2.438 1.614 2.783 1.204 0.345 2.43-0.342 2.741-1.534C76.742 83.801 76.016 82.555 74.813 82.21zM75.075 86.442c-0.5 0.156-1.017-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C75.881 85.831 75.582 86.287 75.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4764",
    d: "M70.811 87.159c-0.37 0.222-0.922 0.023-1.238-0.447 -0.316-0.466-0.269-1.024 0.102-1.247 0.368-0.219 0.925-0.021 1.239 0.446C71.226 86.378 71.181 86.938 70.811 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4765",
    d: "M78.71 83.74c-0.846 0.507-2.117 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.844-0.509 2.118-0.053 2.834 1.019C79.66 81.954 79.556 83.232 78.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4668",
    d: "M53.294 83c0.809 10.899 11.637 23.583 20.506 22.236 10.498 0.106 20.864-7.868 20.864-22.305s-5.087-26.528-21.127-26.528C62.037 56.402 53.294 68.563 53.294 83zM61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4669",
    d: "M72.262 90.163c3.614 0.398 13.873-1.561 14.253-2.847 0.687-2.32-4.534-6.921-12.052-7.844C68.003 78.68 62.9 79.816 61.907 81.6c0.898-6.4 7.7-11.397 15.987-11.434 8.911-0.037 16.148 5.676 16.172 12.765 0.021 7.088-7.185 12.862-16.095 12.902 -8.913 0.037-16.149-5.676-16.173-12.764 0-0.105 0.016-0.208 0.019-0.313C63.147 88.083 68.651 89.764 72.262 90.163z",
    fill: "url(#SvgjsRadialGradient4670)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4674",
    d: "M61.752 82.523c-0.506-2.285 5.191-3.973 12.711-3.051 7.518 0.923 12.738 5.524 12.052 7.844 -0.38 1.286-10.639 3.245-14.253 2.847C68.598 89.758 62.974 88.04 61.752 82.523z",
    fill: "url(#SvgjsRadialGradient4675)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4678",
    d: "M62.148 77.417c4.208-1.978 9.35-2.16 13.838-1.005 2.404 0.561 4.965 1.285 7.063 2.638 1.945 1.135 3.525 2.5 5.002 4.19 -1.342-1.701-2.773-3.118-4.623-4.27 -2.276-1.416-4.769-2.294-7.364-2.916C71.478 74.928 66.342 75.184 62.148 77.417z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4679",
    d: "M62.769 78.02c0.88-0.352 4.065-1 5.456-1.066 1.687-0.082 5.073 0.125 6.735 0.424 3.374 0.608 9.251 2.483 11.678 7.184 0.746 1.445 0.074 2.456-0.123 2.675 0.3-2.426-4.838-6.746-12.052-7.604 -7.52-0.894-13.217 0.743-12.711 2.958 1.222 5.348 6.846 7.013 10.51 7.405 4.099 0.439 11.684-1.539 12.686-1.753 -1.999 1.009-7.524 2.095-9.767 2.303 -0.744 0.07-2.24 0.104-2.986 0.085 -5.949-0.158-10.169-3.175-11.729-7.26C59.464 80.745 60.56 78.902 62.769 78.02z",
    fill: "#302040",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1.0500001,0,0,1.0500001,-6.281062671963525,-4.0434033199447725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4653",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient4654)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1.1000003000000003,0,0,1.1000003000000003,-12.600044666475725,-8.399954627888889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4766",
    d: "M131.788 85.588c-0.869 3.192-4.162 5.073-7.362 4.196 -3.196-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.169-5.076 7.365-4.198C130.772 79.09 132.658 82.392 131.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4767",
    d: "M130.855 85.662c-0.849 2.452-3.408 3.881-5.899 3.199 -2.3-0.631-3.753-2.838-3.563-5.171 0.854-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.593 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.038-0.147 0.06-0.294 0.065-0.439C129.29 84.782 130.089 85.165 130.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4768",
    d: "M126.813 82.21c-1.202-0.344-2.429 0.342-2.738 1.54 -0.312 1.191 0.412 2.438 1.613 2.783 1.204 0.345 2.431-0.342 2.742-1.534C128.741 83.801 128.016 82.555 126.813 82.21zM127.075 86.442c-0.5 0.156-1.018-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C127.881 85.831 127.582 86.287 127.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4769",
    d: "M122.812 87.159c-0.37 0.222-0.923 0.023-1.238-0.447 -0.316-0.466-0.27-1.024 0.102-1.247 0.367-0.219 0.926-0.021 1.239 0.446C123.227 86.378 123.181 86.938 122.812 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4770",
    d: "M130.71 83.74c-0.846 0.507-2.116 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.845-0.509 2.117-0.053 2.834 1.019C131.66 81.954 131.557 83.232 130.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4688",
    d: "M126.063 56.402c-16.04 0-21.127 12.091-21.127 26.528s10.366 22.412 20.864 22.305c8.869 1.347 19.697-11.337 20.506-22.236C146.307 68.563 137.563 56.402 126.063 56.402zM127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 7.52-0.922 13.217 0.767 12.711 3.051C136.627 88.04 131.003 89.758 127.339 90.163z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4689",
    d: "M127.339 90.163c-3.614 0.398-13.873-1.561-14.253-2.847 -0.687-2.32 4.534-6.921 12.052-7.844 6.46-0.792 11.563 0.345 12.556 2.128 -0.898-6.4-7.7-11.397-15.987-11.434 -8.911-0.037-16.148 5.676-16.172 12.765 -0.021 7.088 7.185 12.862 16.095 12.902 8.913 0.037 16.149-5.676 16.173-12.764 0-0.105-0.016-0.208-0.019-0.313C136.453 88.083 130.949 89.764 127.339 90.163z",
    fill: "url(#SvgjsRadialGradient4690)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4694",
    d: "M137.849 82.523c0.506-2.285-5.191-3.973-12.711-3.051 -7.518 0.923-12.738 5.524-12.052 7.844 0.38 1.286 10.639 3.245 14.253 2.847C131.003 89.758 136.627 88.04 137.849 82.523z",
    fill: "url(#SvgjsRadialGradient4695)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4698",
    d: "M137.452 77.417c-4.208-1.978-9.35-2.16-13.838-1.005 -2.404 0.561-4.965 1.285-7.063 2.638 -1.945 1.135-3.525 2.5-5.002 4.19 1.342-1.701 2.773-3.118 4.623-4.27 2.276-1.416 4.769-2.294 7.364-2.916C128.123 74.928 133.259 75.184 137.452 77.417z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4699",
    d: "M136.832 78.02c-0.88-0.352-4.065-1-5.456-1.066 -1.687-0.082-5.073 0.125-6.735 0.424 -3.374 0.608-9.251 2.483-11.678 7.184 -0.746 1.445-0.074 2.456 0.123 2.675 -0.3-2.426 4.838-6.746 12.052-7.604 7.52-0.894 13.217 0.743 12.711 2.958 -1.222 5.348-6.846 7.013-10.51 7.405 -4.099 0.439-11.684-1.539-12.686-1.753 1.999 1.009 7.524 2.095 9.767 2.303 0.744 0.07 2.24 0.104 2.986 0.085 5.949-0.158 10.169-3.175 11.729-7.26C140.137 80.745 139.041 78.902 136.832 78.02z",
    fill: "#302040",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3134",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient3135)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3138",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient3139)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,-1,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(0.9499999,0,0,0.9499999,3.6600012546192175,3.5085313395584166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4815",
    d: "M52.488 73.87c7.475-9.383 20.338-7.822 30.878-6.314 2.681 0.384 5.441 0.672 8.07 1.336 1.884 0.475 3.365 2.622 1.851 4.356 -0.708 0.825-2.253 0.672-3.207 0.652C77.459 73.645 63.193 66.387 52.488 73.87z",
    fill: "#543c32",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,1,-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(0.9499999,0,0,0.9499999,6.341837596674722,3.5163831466438324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4816",
    d: "M147.577 73.49c-2.164-1.448-4.454-2.47-7.043-2.889 -9.497-1.54-27.586 4.79-32.341 3.45 -2.912-0.822-2.323-3.739-1.035-4.458 0.775-0.433 0.99-0.422 7.909-1.612C126.824 65.961 139.988 64.355 147.577 73.49z",
    fill: "#543c32",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1.0500001,0,0,1.0500001,-5.003458683960346,-5.148309132352082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3509",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3510",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3511",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#fff5ef",
    strokeWidth: "none",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(0.9799999,0,0,0.9998999000000001,2.000010000000003,0.001814812915991837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4962",
    d: "M71.7 128.57c0.26 1.18 0.08 1.62-0.33 2.5C71.68 129.72 71.69 129.7 71.7 128.57zM98.59 157.65c-0.02-1.21-0.44-1.85-1.56-2.22C97.93 156.04 98.36 156.59 98.59 157.65zM94.8 156.56c-0.05-1.04-0.28-1.67-1.1-2.33C94.26 155.02 94.5 155.56 94.8 156.56zM90.87 155.24c0.08 0.46 0.74 1.31 1.33 1.5C91.71 156.46 90.87 155.24 90.87 155.24zM87.2 153.57c0.08 0.24 0.68 1.88 0.83 1.67C88.04 155.24 87.08 153.22 87.2 153.57zM89.7 150.74c-0.25 1-0.3 1.59-0.17 2.67C89.63 152.79 89.71 151.23 89.7 150.74zM91.87 147.9c-0.09 0.77-0.1 1.57 0 2.33C91.96 149.57 91.98 148.8 91.87 147.9zM93.04 152.74c0.66-0.85 0.89-1.29 1.17-2.33C94 150.74 93.19 152.38 93.04 152.74zM96.7 150.4c-0.08 1.28 0.04 1.85 0.5 2.83C96.84 151.54 96.96 152.13 96.7 150.4zM95.2 148.9c0.42-0.82 0.57-1.29 0.67-2.17C95.69 147.17 95.3 148.49 95.2 148.9zM99.04 147.4c-0.07 0.62 0.05 1.77 0.67 1.67C99.24 149.15 99.1 147.86 99.04 147.4zM95.2 144.9c0.32-0.74 0.56-1.58 0.67-2.33C95.54 143.32 95.32 144.13 95.2 144.9zM88.2 146.74c-0.29 0.88-0.39 1.45-0.33 2.5C87.97 148.78 88.17 147.23 88.2 146.74zM85.37 153.07c0.51-1 0.7-1.62 0.83-2.67C85.97 150.96 85.52 152.4 85.37 153.07zM83.04 150.57c-0.54 0.6 0.17 1.67 0.17 1.67C83.19 151.52 82.81 151.17 83.04 150.57zM84.04 144.8c0-0.06-0.12 0.23 0.16 2.6 0.06-2.55-0.17-2.93-0.17-2.5C84.04 144.9 84.04 144.86 84.04 144.8zM80.2 146.9c0.08 1.47 0.03 2.06 0.33 3C80.43 147.77 80.47 147.9 80.2 146.9zM77.7 147.07c-0.18 0.83-0.21 1.34 0.33 2C77.67 148.33 77.7 147.92 77.7 147.07zM73.54 144.9c0.02-0.51-0.01-1.11-0.15-1.68C73.39 143.13 73.32 143.89 73.54 144.9zM75.26 145.49c0 0 0.61-2.92 0.61-2.92C75.45 143.28 75.26 145.49 75.26 145.49zM78.7 141.9c-0.55 0.52-0.86 1.66-0.83 2.33C77.98 143.79 78.41 142.34 78.7 141.9zM81.37 144.74c0.25-1.07 0.3-1.7 0.17-2.83C81.43 142.58 81.36 144.19 81.37 144.74zM81.2 136.24c-0.2 0.65-0.24 0.95-0.17 1.67C81.05 137.83 81.2 136.3 81.2 136.24zM78.54 138.9c0.46-0.63 0-2.33 0-2.33S78.67 138.6 78.54 138.9zM74.87 137.74c0.17 0.83 0.46 1.74 0.83 2.5C75.54 139.41 75.25 138.53 74.87 137.74zM71.54 137.74c-0.3 1.81-0.06 2.33 0.33 3.33C71.63 139.59 71.56 139.4 71.54 137.74zM69.04 135.74c-0.4 0.64-0.54 2.16 0.17 3C68.8 137.97 68.84 136.33 69.04 135.74zM69.87 130.57c0 0-0.5 0.94-0.5 2.33C69.55 132.11 69.75 131.2 69.87 130.57zM73.04 133.07c0 0-0.83 0.06-0.5 2.5C72.91 132.51 73.04 133.07 73.04 133.07zM77.2 134.07c0.27-0.84 0.45-1.75 0.5-2.67C77.42 132.26 77.26 133.17 77.2 134.07zM75.2 127.9c-0.46 1.05-0.54 1.45-0.5 2.5C74.7 130.4 75.2 127.9 75.2 127.9zM79.2 126.24c-0.67 0.58-0.88 2.11-0.83 3C78.83 126.52 79.2 126.24 79.2 126.24zM83.7 126.4c-0.8 0.64-1.12 1.1-1.33 2.33C82.76 127.78 82.85 127.44 83.7 126.4zM86.54 129.07c0.64-0.63 1.5-3.33 1.5-3.33C87.86 125.39 86.75 128.72 86.54 129.07zM91.54 125.74c-0.56 0.13-1.43 2.64-1.67 3.17C90.17 128.48 91.54 125.74 91.54 125.74zM94.7 125.57c-0.48 0.99-0.74 1.51-1 2.67C94.18 127.29 94.41 126.51 94.7 125.57zM98.7 125.07c-0.76 1.71-0.43 1.22-1.33 3C97.94 127.36 98.37 126.74 98.7 125.07zM128.3 128.57c-0.26 1.18-0.08 1.62 0.33 2.5C128.32 129.72 128.31 129.7 128.3 128.57zM103.46 155.24c-1.12 0.37-1.49 0.68-1.5 1.89C102.19 156.06 102.56 155.84 103.46 155.24zM106.32 154.71c-0.82 0.66-1.14 1.49-1.19 2.53C105.43 156.24 105.77 155.49 106.32 154.71zM107.8 156.74c0.59-0.19 1.26-1.04 1.33-1.5C109.13 155.24 108.29 156.46 107.8 156.74zM111.96 155.24c0.15 0.21 0.75-1.42 0.83-1.67C112.92 153.22 111.96 155.24 111.96 155.24zM110.46 153.4c0.13-1.08 0.08-1.67-0.17-2.67C110.29 151.23 110.37 152.79 110.46 153.4zM108.13 150.24c0.1-0.77 0.09-1.57 0-2.33C108.02 148.8 108.04 149.57 108.13 150.24zM105.8 150.4c0.28 1.04 0.51 1.49 1.17 2.33C106.81 152.38 106 150.74 105.8 150.4zM102.8 153.24c0.46-0.99 0.58-1.55 0.5-2.83C103.04 152.13 103.16 151.54 102.8 153.24zM104.13 146.74c0.1 0.88 0.24 1.35 0.67 2.17C104.7 148.49 104.31 147.17 104.13 146.74zM101.3 148.07c0.61 0.1 0.74-1.05 0.67-1.67C101.9 146.86 101.76 148.15 101.3 148.07zM104.13 142.57c0.11 0.75 0.35 1.59 0.67 2.33C104.68 144.13 104.46 143.32 104.13 142.57zM112.13 149.24c0.06-1.05-0.04-1.62-0.33-2.5C111.83 147.23 112.03 148.78 112.13 149.24zM113.8 150.4c0.13 1.04 0.33 1.67 0.83 2.67C114.48 152.4 114.03 150.96 113.8 150.4zM116.8 152.24c0 0 0.71-1.06 0.17-1.67C117.19 151.17 116.81 151.52 116.8 152.24zM115.96 144.9c0-0.43-0.22-0.05-0.17 2.5 0.28-2.37 0.16-2.66 0.16-2.6C115.96 144.86 115.96 144.9 115.96 144.9zM119.46 149.9c0.3-0.94 0.25-1.53 0.33-3C119.53 147.9 119.57 147.77 119.46 149.9zM121.96 149.07c0.54-0.66 0.51-1.17 0.33-2C122.3 147.92 122.33 148.33 121.96 149.07zM126.61 143.23c-0.14 0.57-0.17 1.17-0.15 1.68C126.68 143.89 126.61 143.13 126.61 143.23zM124.13 142.57c0 0 0.61 2.92 0.61 2.92S124.55 143.28 124.13 142.57zM122.13 144.24c0.03-0.67-0.29-1.81-0.83-2.33C121.59 142.34 122.02 143.79 122.13 144.24zM118.46 141.9c-0.14 1.13-0.09 1.76 0.17 2.83C118.64 144.19 118.57 142.58 118.46 141.9zM118.96 137.9c0.07-0.72 0.03-1.02-0.17-1.67C118.8 136.3 118.95 137.83 118.96 137.9zM121.46 136.57c0 0-0.46 1.7 0 2.33C121.33 138.6 121.46 136.57 121.46 136.57zM124.3 140.24c0.37-0.76 0.67-1.67 0.83-2.5C124.75 138.53 124.46 139.41 124.3 140.24zM128.13 141.07c0.4-1 0.64-1.53 0.33-3.33C128.44 139.4 128.37 139.59 128.13 141.07zM130.8 138.74c0.71-0.84 0.57-2.36 0.17-3C131.16 136.33 131.2 137.97 130.8 138.74zM130.63 132.9c0-1.4-0.5-2.33-0.5-2.33C130.25 131.2 130.45 132.11 130.63 132.9zM127.46 135.57c0.33-2.44-0.5-2.5-0.5-2.5S127.09 132.51 127.46 135.57zM122.3 131.4c0.05 0.91 0.23 1.83 0.5 2.67C122.74 133.17 122.58 132.26 122.3 131.4zM125.3 130.4c0.04-1.05-0.04-1.45-0.5-2.5C124.8 127.9 125.3 130.4 125.3 130.4zM121.63 129.24c0.05-0.89-0.17-2.42-0.83-3C120.8 126.24 121.17 126.52 121.63 129.24zM117.63 128.74c-0.21-1.24-0.53-1.7-1.33-2.33C117.15 127.44 117.24 127.78 117.63 128.74zM111.96 125.74c0 0 0.86 2.7 1.5 3.33C113.25 128.72 112.14 125.39 111.96 125.74zM110.13 128.9c-0.24-0.53-1.1-3.04-1.67-3.17C108.46 125.74 109.83 128.48 110.13 128.9zM106.3 128.24c-0.26-1.15-0.52-1.68-1-2.67C105.59 126.51 105.82 127.29 106.3 128.24zM102.63 128.07c-0.91-1.78-0.57-1.29-1.33-3C101.63 126.74 102.05 127.36 102.63 128.07zM100.51 151.66c-1.02 1.58-0.98 2.27-0.95 3.27C99.85 153.5 99.83 153.51 100.51 151.66zM97.93 142.95c0.51 1.42 0.57 1.57 0.82 2.59C98.72 144.45 98.5 143.87 97.93 142.95zM100.79 145.08c0.25-1.02 0.78-0.71 1.29-2.13C101.5 143.87 100.81 144 100.79 145.08z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0.5,-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(0.8499995000000001,0,0,0.8499995000000001,15.000049999999987,19.137659159416188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4943",
    d: "M102.33 124.84c-0.64-0.1-1.76-0.16-2.25 0.27 -0.03 0.03-0.05 0.05-0.08 0.08 -0.03-0.03-0.05-0.06-0.08-0.08 -0.49-0.42-1.61-0.37-2.25-0.27L75.2 130.4l22.66-0.87c0.61 0.03 1.2-0.19 1.64-0.62 0.21-0.21 0.78-0.21 1 0 0.44 0.42 1.03 0.64 1.64 0.62l22.66 0.87L102.33 124.84z",
    fill: "#543c32",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(0.9799999,0,0,0.9998999000000001,2.0249094927829674,0.005241765688701605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4900",
    d: "M152.983 98.604c-4.563-12.435 0.717-31.506-8.205-45.615 -4.064-6.762-7.597-11.409-6.95-19.276l-0.368-0.124c-0.862 1.352-1.994 2.82-2.745 3.76 0.427-1.091 1.123-2.762 1.753-4.023l-0.332-0.218c-2.585 3.073-4.805 4.649-7.859 5.5 3.3-2.32 6.949-6.357 8.546-8.595l-0.271-0.284c-11.319 7.283-24.164 7.382-35.496 7.471 -10.227 0.076-16.579-0.155-23.953-4.441 -5.321 1.764-9.511 1.539-14.116-1.635 -14.414 27.947-8.01 13.957-16.627 65.764 -5.004-6.67-6.458-10.912-7.642-17.267 -0.313-2.027-0.619-5.154-0.429-7.215l-0.063-0.065c-4.452-9.77-6.553-15.333-5.495-34.712 0.785-8.04 2.533-14.076 7.574-20.398 -0.665-3.435-0.729-6.898-0.277-10.21 -2.64-4.827-4.457-9.795-5.165-11.57 3.688 2.823 3.993 2.986 7.07 3.957 0.704-1.937 1.73-3.861 2.387-4.865 0.297 2.238 0.533 3.75 1.203 5.925 0.228 0.055 1.313 0.349 1.66 0.442 -0.199-1.324-0.381-1.938-0.353-3.125 0.571 1.302 1.053 1.604 2.71 3.626 1.834 0.385 1.394 0.328 1.944 0.328 -2.669-4.183-4.47-7.885-4.927-13.515 3.653 2.081 8.764 3.27 14.101 3.27 12.539 0 25.369-9.412 43.169-9.412 15.425 0 28.771 8.558 34.683 18.303 -0.006-2.514-0.113-4.594 0.794-7.178 0 0 0.105 3.705 0.105 6.592l0.396 0.037c0.62-3.301 1.928-6.115 4.088-8.773 -1.918 5.158-1.188 2.404-3.334 8.702l0.348 0.187c1.431-1.839 2.603-3.139 6.019-4.862 -2.468 2.473-4.355 3.89-5.522 5.639l0.301 0.259c1.456-1.32 2.971-1.82 4.512-0.613 -2.481-0.902-3.946 0.679-5.648 2.675 6.619 1.091 10.21 4.91 14.864 10.015 10.712 12.352 13.533 24.411 7.723 41.506 2.435 5.263 2.06 17.125-3.375 26.686C159.779 86.867 155.941 93.789 152.983 98.604z",
    fill: "#543c32",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4901",
    d: "M62.299 30.371c0.359 0.334 0.718 0.668 1.074 1.004 -0.129-0.085-0.258-0.164-0.388-0.253 -14.414 27.947-8.01 13.957-16.627 65.764 -5.004-6.67-6.458-10.912-7.642-17.267 -0.313-2.027-0.619-5.154-0.429-7.215l-0.063-0.065c-4.452-9.77-6.553-15.333-5.495-34.712 0.785-8.04 2.533-14.076 7.574-20.398 -0.654-3.378-0.72-6.782-0.293-10.044 0.597 0.874 1.223 1.725 1.863 2.565C42.304 12.374 42.669 14.933 42 17c-9.539 29.478-4 43 2 64 -2.464-15.931-7.142-36.185 5.619-48C44.168 46.096 45.673 52.034 47 61 47.917 49.082 52.195 37.996 62.299 30.371zM155.432 13.06c-0.376-0.412-0.742-0.812-1.106-1.207 -0.382 0.255-0.774 0.489-1.159 0.737 14.956 30.661 0.594 27.717 4.017 41.409C161.183 63.999 156 70 156 80c0-15-0.681-25.439-8.96-37.175 -2.796-3.963-3.581-17.423-5.465-24.074C118.373 33 84.002 35.981 47.916 7.183c17 6 51.649 1.35 63.543-6.316 -13.558 2.461-41.862 2.608-54.59-2.631 30.5-2.37 30.131-12.16 56.131-14C100.5-20.431 73.196-8.51 60.658-8.51c-5.336 0-10.447-1.188-14.101-3.27 0.457 5.63 2.258 9.333 4.927 13.515 -0.551 0-0.11 0.057-1.944-0.328 -1.658-2.022-2.14-2.325-2.71-3.626 -0.029 1.187 0.154 1.801 0.353 3.125 -0.347-0.093-1.433-0.387-1.66-0.442 -0.67-2.175-0.906-3.687-1.203-5.925 -0.656 1.004-1.683 2.928-2.387 4.865 -3.078-0.971-3.382-1.134-7.07-3.957 0.708 1.775 2.525 6.744 5.165 11.57 -0.007 0.055-0.009 0.111-0.016 0.166 6.305 9.235 15.169 16.471 23.363 24.192 4.454 2.924 8.558 3.096 13.729 1.382 7.374 4.286 13.727 4.517 23.953 4.441 11.332-0.088 24.177-0.188 35.496-7.471l0.271 0.284c-1.597 2.238-5.246 6.275-8.546 8.595 3.055-0.852 5.274-2.428 7.859-5.5l0.332 0.218c-0.63 1.262-1.326 2.932-1.753 4.023 0.751-0.94 1.883-2.408 2.745-3.76l0.368 0.124c-0.646 7.868 2.886 12.514 6.95 19.276 8.922 14.109 3.643 33.181 8.205 45.615 2.958-4.815 6.796-11.736 6.796-17.352 5.435-9.561 5.81-21.423 3.375-26.686C168.965 37.471 166.144 25.412 155.432 13.06zM156.165 38.709c-0.33-9.524-6.633-21.612-6.633-21.612 -2.946-5.204-5.579-7.687-9.996-8.695 12.426 0.619 17.306 19.179 16.769 28.875C156.254 38.177 156.165 38.709 156.165 38.709zM127.907-1.507c3.283 2.663 4.067 3.423 7.296 7.909 -16.653-29.889-49.333-7.27-59.667-8C86.041 0.573 109.793-14.79 127.907-1.507zM136.369 11.485C116.408 28.033 85.929 21.023 61 13.21 85.827 24.581 117.435 30.734 136.369 11.485zM57.869 29.485c-6.539 3.425-9.616 12.05-9.9 17.75C49.19 42.316 52.854 33.291 57.869 29.485zM49.619 24.735c-9.359 5.699-11.174 18.771-10.25 29.75C40.353 44.343 42.181 31.11 49.619 24.735zM117.064 12.34c-1.006 0.215-7.259 1.072-10.672 1.195 -2.661 0.155-13.037 0.328-22.391-0.048 9.655 2.069 15.454 2.454 22.496 2.045 8.106-0.293 15.36-1.898 21.371-6.796C123.633 11.067 121.828 11.399 117.064 12.34zM150.609 38.885c0 0-0.256-0.441-0.588-1.102 -0.911-1.527-1.945-5.681-5.938-18.736 2.966 24.195 7.817 19.782 9.991 32.283C154.075 46.834 153.761 44.529 150.609 38.885z",
    fill: "#452c22",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4902",
    d: "M157.853 68.131c0.364-3.246 0.217-1.758 0.257-3.61 0.306-6.244-3.426-11.479-1.154-18.987 1.854-5.453 2.925-6.308 2.113-15.801 -0.119-1.37-0.474-4.774-1.102-5.998 0.856 1.489 1.422 4.245 1.725 5.934 1.687 9.543 0.268 10.992-1.521 16.267C155.781 53.906 160.368 57.422 157.853 68.131zM141.575 18.751c1.117 30.37 7.276 23.316 12.717 41.752C150.598 38.757 147.181 56.786 141.575 18.751zM48.369 34.235c-9.19 11.563-8.262 19.899-6 37C42.165 53.925 40.055 47.355 48.369 34.235zM41.772 17.714c-5.274 16.319-6.429 23.684-3.897 41.285C37.406 41.353 37.518 37.458 41.772 17.714zM61.952 30.641C52.322 37.56 47.295 50.217 47 61 48.482 50.695 54.012 37.697 61.952 30.641zM128.855 24.594c-12.051 4.437-31.667 5.625-45.988 1.322C71.706 22.661 54.279 11.723 44.905 4.845c8.498 6.765 23.471 16.807 33.926 20.776 10.863 4.059 27.887 5.567 41.081 2.245 9.248-2.324 14.041-4.52 21.663-9.114C138.182 20.612 133.184 23.242 128.855 24.594zM102.813-11.594c12.167-2.285 26.509 5.558 34.057 14.83 -7.897-11.318-20.837-16.949-28.562-17.083C95.629-14.067 82.513-3.204 56.869-2.265 80.982-1.203 92.573-9.936 102.813-11.594zM112.369 1.235c-17.289 6.143-30.64 7.613-48.807 8.58C82.325 10.97 95.739 9.15 112.369 1.235zM130.536 4.738c-10.662 5.027-15.33 5.851-37.337 7.191C106.996 12.486 119.885 11.769 130.536 4.738zM95.248 20.023c10.644 1.237 29.289-0.105 38.621-9.788 -11.27 9.494-32.119 9.154-48.38 8.508C91.713 19.714 90.59 19.552 95.248 20.023zM140.869 10.735c7.629 2.809 9.489 16.193 12.5 27C152.022 28.156 149.721 12.813 140.869 10.735z",
    fill: "#634e45",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4903",
    d: "M155.579 12.925c-4.348-4.769-8.252-8.97-14.63-10.02 2.094-2.463 3.566-3.379 6.25-1.85 -1.59-1.871-3.417-2.226-5.63-0.22 1.271-1.905 3.468-3.46 6.3-6.43 -4.231 1.985-5.503 3.34-7.12 5.42 2.285-6.703 1.3-3.128 3.72-9.75 -2.529 2.836-4.146 5.92-4.859 9.72 0-5.903-0.185-5.14-0.07-7.72 -1.387 3.089-1.229 5.81-1.229 7.59 -2.233-3.682-5.514-6.8-9.051-9.35 -25.054-18.289-50.039-1.456-63.58 0.58 -5.489 0.927-13.714 0.338-19.35-3.04 0.398 5.764 2.183 9.592 4.79 13.68 -0.001 0-1.47-0.31-1.47-0.31 -2.019-2.434-2.214-2.356-2.96-4.33 -0.191 1.763 0.101 2.74 0.25 3.74 -0.498-0.13-0.957-0.268-1.26-0.34 -0.743-2.414-0.958-4.25-1.23-6.29 -0.614 0.785-1.922 3.18-2.64 5.15 -2.999-0.948-3.214-1.099-7.43-4.33 0.5 1 2.309 6.461 5.44 12.23 -0.47 3.534-0.328 7.06 0.27 10.12 -5.025 6.312-6.77 12.346-7.56 20.44 -1.041 19.059 0.867 24.611 5.53 34.82 0.01 0.01 0.01 0.03 0.02 0.04 -0.177 1.971 0.119 5.102 0.44 7.18 1.179 6.332 2.625 10.693 7.91 17.65 0.02 0.02 0.03 0.05 0.05 0.07 3.395-20.368 3.045-20.867 3.77-25.89 3.572-25.712 3.417-21.872 12.81-40.07 3.813 2.628 8.035 3.552 14.02 1.56 4.342 2.524 8.776 4.45 21.06 4.45 12.171-0.152 26.176 0.412 38.52-7.53 -1.87 2.622-6.118 7.154-9.46 9.18 3.479-0.736 5.975-2.137 9.09-5.84 -0.957 1.915-2.083 4.814-2.17 5.16 0.15-0.18 2.15-2.57 3.51-4.7 -0.653 7.945 2.894 12.597 6.98 19.4 8.956 14.163 3.511 33.521 8.33 45.96 3.09-4.996 7.04-12.086 7.04-17.75 5.21-9.086 5.956-21.111 3.39-26.75C168.587 38.924 167.533 26.708 155.579 12.925zM46.789-2.465c0.488 1.389 0.595 1.359 2.49 3.61 -0.94-0.195-1.565-0.332-2.13-0.46C46.93-0.371 46.789-1.375 46.789-2.465zM44.279-5.125c0.094 1.532 0.459 3.542 0.99 5.31 -2.865-0.737-1.8-0.504-2.8-0.8C43.292-3.089 43.602-3.715 44.279-5.125zM45.999 95.095c-4.216-7.605-5.323-10.191-6.49-17.89 -0.114-0.886-0.472-3.446-0.49-4.67 -6.07-13.88-8.352-40.236 1.21-54.74 0-0.01 0-0.01 0-0.01s0.399-0.624 1.12-1.52c-0.267-1.344-0.531-4.18-0.44-7.28 0.74 1.32 1.58 2.52 2.33 3.67 0-0.003 0.59 0.781 0.59 0.8 4.551 5.79 8.754 10.604 18.92 17.75C50.544 50.979 51.301 44.3 45.999 95.095zM163.639 48.206c-0.356 2.358-1.123 5.583-1.539 6.99 2.78 7.068-0.257 20.417-3.061 26.38 -1.226 7.093-2.545 8.521-6.01 15.59 -2.477-11 2.583-30.519-6.76-45.08 -6.059-10.044-8.657-11.36-7.23-23.77 0 0 0.061-0.675 0.08-0.85 -12.628 7.721-26.576 8.594-44.97 8.2 -5.317 0-12.5-0.668-16.98-3.44 -9.081 2.583-12.45-1.437-20.01-7.34 -8.163-6.937-13.709-12.994-20.55-27.27 3.843 3.118 11.537 4.689 16.39 5.5 -3.273-4.363-5.199-8.349-6.07-14 3.48 2.32 11.82 4.603 19.17 3.79 13.534-1.271 32.484-15.167 55.77-4.63 10.804 4.767 16.286 11.476 17.57 15 0.01 0 0.02 0.01 0.04 0.01 0.06 0.02 0.12 0.03 0.189 0.04 0.017 0.018 0.332 0.09 0.36 0.09 6.976 2.325 7.443 2.759 14.2 10.64C158.026 18.715 167.168 28.016 163.639 48.206z",
    fill: "#26130b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4812",
    d: "M150.82 85.61c0.02 6.14-1.89 12.16-4.01 14.71 -2.43 2.93-8.12 4.76-14.84 4.76 -5.93 0-11.52-1.45-14.96-3.87 -5.16-3.64-9.63-11.19-11.25-18.06C115.62 75.7 141.43 75.3 150.82 85.61zM49.18 85.61c-0.02 6.14 1.89 12.16 4.01 14.71 2.43 2.93 8.12 4.76 14.84 4.76 5.93 0 11.52-1.45 14.96-3.87 5.16-3.64 9.63-11.19 11.25-18.06C84.38 75.7 58.57 75.3 49.18 85.61z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4813",
    d: "M105.77 83.14c-0.57-2.43-0.79-4.79-0.55-6.85 0.44-3.77 2.25-6.32 5.37-7.56 1.76-0.7 6.71-1.17 12.31-1.17 4.01 0 17.49 0.3 22.45 4.22 2.98 2.35 4.82 6.18 5.33 11.07 0.1 0.91 0.14 1.83 0.14 2.75C141.43 75.3 115.62 75.7 105.77 83.14zM94.79 76.3c-0.44-3.77-2.25-6.32-5.37-7.56 -1.76-0.7-6.71-1.17-12.31-1.17 -4.01 0-17.49 0.3-22.45 4.22 -2.98 2.35-4.82 6.18-5.33 11.07 -0.1 0.91-0.14 1.83-0.14 2.75 9.39-10.31 35.2-9.91 45.06-2.47C94.81 80.71 95.03 78.36 94.79 76.3z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4814",
    d: "M154.89 79.22c-0.1-0.36-0.75-0.8-1.44-1.05 -0.47-0.17-1.99-0.27-2.92-0.32 -4.25-11.92-16.29-11.04-42.6-11.11 -0.72-1-0.42-0.72-7.93-0.74 -7.52 0.01-7.21-0.26-7.93 0.74 -26.31 0.07-38.35-0.81-42.6 11.11 -0.93 0.05-2.45 0.15-2.92 0.32 -0.69 0.25-1.34 0.69-1.44 1.05 -0.1 0.36-0.14 1.82-0.06 2.1 0.08 0.28 0.61 0.93 0.61 0.93s0.04-0.04 0.1-0.1c0.17 0.32 0.73 0.91 2.54 1.03 -0.77 7.48 1.61 14.5 4.24 17.67 5.73 6.92 23.35 6.43 30.95 1.07 7.2-5.07 12.9-16.95 12.21-25.22 1.81-1.21 6.94-1.21 8.62 0 -0.69 8.27 5.01 20.15 12.21 25.22 7.6 5.36 25.22 5.85 30.95-1.07 2.63-3.17 5.01-10.19 4.24-17.67 1.81-0.12 2.37-0.71 2.54-1.03 0.07 0.06 0.1 0.1 0.1 0.1s0.53-0.65 0.61-0.93C155.04 81.04 155 79.58 154.89 79.22zM82.69 100.8c-7.64 5.39-24.38 4.92-29.12-0.8 -3.92-4.72-6.89-21.27 1.39-27.82 6.53-5.16 30.21-4.6 34.26-2.98 2.94 1.17 4.64 3.58 5.06 7.15C95.2 84.08 89.56 95.96 82.69 100.8zM95.4 74.74c-0.49-2.14-1.5-3.87-2.95-5.15 0.14-0.53 1.33-1.26 1.56-1.76 2.26-0.01 9.72-0.01 11.98 0 0.23 0.5 1.42 1.23 1.56 1.76 -1.45 1.28-2.46 3.01-2.95 5.15C101.64 73.83 98.23 73.87 95.4 74.74zM146.43 100c-4.74 5.71-21.48 6.18-29.12 0.8 -6.87-4.84-12.5-16.72-11.59-24.44 0.42-3.58 2.12-5.98 5.06-7.15 4.06-1.62 27.73-2.18 34.26 2.98C153.32 78.72 150.35 95.28 146.43 100z",
    fill: "#c0c0c0",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect3119",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText3120",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 38.76297378540039,
    y: 182.42838287353516,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan3121",
    dy: 13,
    x: 38.76297378540039
  }, "Created on svgAvatars.com")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b4fe8cd31cbfa6644d941008be74f8b9.svg";
export { ForwardRef as ReactComponent };